module.exports = __WEBPACK_EXTERNAL_MODULE__1346__;